import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";
import {
    FlightZoneApplicationPurpose,
    FlightZoneSelectOption,
    RestrictionExclusions,
    SecuringOwnFlightsRestrictionExclusions,
} from "../../../models/flight-zone-shared.models";

interface SecuringOwnFlightsExclusionsSummaryComponentState {
    restrictionExclusions: SecuringOwnFlightsRestrictionExclusions | undefined;
}

@Component({
    selector: "dss-shared-lib-securing-own-flights-exclusions-summary[restrictionExclusions]",
    templateUrl: "./securing-own-flights-exclusions-summary.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class SecuringOwnFlightsExclusionsSummaryComponent {
    protected readonly restrictionExclusions$ = this.localStore.selectByKey("restrictionExclusions");

    @Input() public set restrictionExclusions(value: RestrictionExclusions | undefined) {
        if (value?.purpose !== FlightZoneApplicationPurpose.SecuringOwnFlights) {
            return;
        }

        this.localStore.patchState({ restrictionExclusions: value });
    }

    constructor(private readonly localStore: LocalComponentStore<SecuringOwnFlightsExclusionsSummaryComponentState>) {
        this.localStore.setState({
            restrictionExclusions: undefined,
        });
    }

    protected formatCoursesToDisplay(courses: FlightZoneSelectOption<string>[]): string {
        return courses.map((course) => course.title).join(", ");
    }
}
